export default "__VITE_ASSET__75c2e0ff__"